import type { SxStyleFunc } from '@aibees/shared/theme';

interface Popover {
  width: string;
  dialogMode: boolean;
  popoverHeight: string;
}

export const root: SxStyleFunc<Popover> = ({
  width,
  dialogMode,
  popoverHeight,
}) => ({
  display: 'flex',
  width,
  // position: 'relative',
  // height: dialogMode ? popoverHeight : 'auto',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
});

export const popoverHeight: SxStyleFunc<number> = (height) => ({
  height: '200px',
});
